if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {

        
//        const thumbnails = document.querySelectorAll('.thumbnail-item-vertical');

// console.log('Total vertical thumbnails:', thumbnails.length);

// let matchedThumbnail = null;

// thumbnails.forEach((thumb, index) => {
//   const target = thumb.getAttribute('data-target');
//   console.log(`Thumbnail ${index + 1} target:`, target);

//   if (target === mediaId) {
//     matchedThumbnail = thumb;
//   }
// });

// if (!matchedThumbnail) {
//   console.warn('❌ No matching thumbnail found for mediaId:', mediaId);
//   return;
// }

// // 🔥 ACTIVE STATE APPLY
// thumbnails.forEach((item) => item.classList.remove('is-active'));
// matchedThumbnail.classList.add('is-active');

// // aria-current
// document
//   .querySelectorAll('.thumbnail-item-vertical button')
//   .forEach((btn) => btn.removeAttribute('aria-current'));

// const btn = matchedThumbnail.querySelector('button');
// if (btn) btn.setAttribute('aria-current', 'true');

// // scroll
// matchedThumbnail.scrollIntoView({
//   behavior: 'smooth',
//   block: 'nearest',
// });

 if (!mediaId) {
  console.warn('❌ mediaId missing');
  return;
}

// Delay so Shopify DOM update complete ho jaye
requestAnimationFrame(() => {
  const thumbnails = document.querySelectorAll('.thumbnail-item-vertical');

  if (!thumbnails.length) return;

  let matchedThumbnail = null;

  thumbnails.forEach((thumb) => {
    const target = thumb.getAttribute('data-target');
    if (target && target.includes(mediaId)) {
      matchedThumbnail = thumb;
    }
  });

  if (!matchedThumbnail) {
    console.warn('❌ No matching thumbnail for mediaId:', mediaId);
    return;
  }

  // ACTIVE STATE
  thumbnails.forEach((item) => item.classList.remove('is-active'));
  matchedThumbnail.classList.add('is-active');

  document
    .querySelectorAll('.thumbnail-item-vertical button')
    .forEach((btn) => btn.removeAttribute('aria-current'));

  const btn = matchedThumbnail.querySelector('button');
  if (btn) btn.setAttribute('aria-current', 'true');

  // Scroll only the thumbnail strip, never the page.
  let container = matchedThumbnail.parentElement;

  while (container && container !== document.body) {
    const overflowY = getComputedStyle(container).overflowY;
    const canScroll =
      /^(auto|scroll)$/.test(overflowY) &&
      container.scrollHeight > container.clientHeight;

    if (canScroll) break;
    container = container.parentElement;
  }

  if (!container || container === document.body) return;

  const thumbnailRect = matchedThumbnail.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();
  const visibleTop = containerRect.top + container.clientTop;
  const visibleBottom = visibleTop + container.clientHeight;

  if (thumbnailRect.top < visibleTop) {
    container.scrollTo({
      top: container.scrollTop + thumbnailRect.top - visibleTop,
      behavior: 'smooth',
    });
  } else if (thumbnailRect.bottom > visibleBottom) {
    container.scrollTo({
      top: container.scrollTop + thumbnailRect.bottom - visibleBottom,
      behavior: 'smooth',
    });
  }
});



        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}